.toolbar {
  top: 1.25em;
  display: flex;
  position: absolute;
  flex-direction: row;
}

.rightToolbar {
  @extend .toolbar;
  right: 1em;
}

.leftToolbar {
  @extend .toolbar;
  left: 1em;
}
